<template>
  <div
    :title="roadName"
    class="my-road"
    :style="roadStyle"
    :class="{ current: currentRoadStyle }"
  >
    <!-- <transition name="plus-icon" v-for="item in 4" :key="item"> -->
    <div v-show="true" class="my-road-box" :style="roadBoxStyle">
      <div
        class="road-idx number"
        :style="roadFontStyle"
        v-if="getRoadIdx > 0 && currentRoadStyle && false"
        v-html="getRoadIdx"
      ></div>
    </div>
    <!-- </transition> -->
    <template v-for="(item_car, id) in carInfo" :key="id">
      <!--div
        @click="carClick(item_car)"
        class="my-car"
        :class="item_car.isGPS && 'move'"
        :style="{
          animationDuration: id * 5 + 30 + 's',
          zIndex: showPop(item_car.deviceNo) ? 3 : 1,
          left: item_car.left,
        }"
      -->
      <div
        @click="carClick(item_car)"
        @mouseenter="carDetailShow(item_car)"
        @mouseleave="carDetailHide()"
        :class="{
          'my-car': true,
          moveLeft: item_car.driveStatus == 'forward' ? true : false,
          moveRight: item_car.driveStatus == 'back' ? true : false,
          moveStop: item_car.driveStatus == 'stop' ? true : false,
        }"
        :style="{
          zIndex: showPop(item_car.deviceNo) ? 3 : 1,
          left: item_car.left,
        }"
      >
        <transition name="plus-icon">
          <div class="carInfo" :style="carInfoStyle" v-if="showPop(item_car.deviceNo)">
            <div class="typeName">{{ carInfoBox(item_car) }}</div>
            <div class="typeName2" v-if="item_car.todayDistance !== '0.00'">
              正在清扫<span>{{ item_car.road_name }}</span>
            </div>
            <div class="typeName2" v-else>
              车辆在<span>{{ item_car.road_name }}</span>
            </div>
            <div class="typeName2" v-if="item_car.todayDistance !== '0.00'">
              今日已清扫<span>{{ item_car.todayDistance }}</span
              >公里
            </div>
            <div class="typeName2" v-else>今日无清扫数据</div>
          </div>
        </transition>
      </div>
    </template>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    roadWidth: {
      // required: true,
    },
    roadHeight: {
      // required: true,
    },
    roadTop: {
      // required: true,
    },
    roadLeft: {
      // required: true,
    },
    roadRotate: {
      // required: true,
    },
    startLnd: {
      // required: true,
    },
    startLat: {
      // required: true,
    },
    endLnd: {
      // required: true,
    },
    endLat: {
      // required: true,
    },
    todayDistance: {
      // required: true,
    },
    roadId: {},
    roadHasCar: {
      type: Boolean,
      default: false,
    },
    carInfo: {
      default: () => [],
    },
    currentRoad: {
      // type: [Object, String],
      default: () => [],
    },
    currentRoadInfo: {
      default: () => [],
    },
    otherRoadInfo: {
      default: () => [],
    },
    carCurrentID: {
      default: () => [],
    },
    roadType: {
      default: () => "",
    },
    roadName: {
      default: () => "",
    },
  },
  data() {
    //这里存放数据
    return {
      newCurrentRoad: [],
      newCurrentRoadInfo: [],

      newOtherRoadInfo: [],
      newOtherRoad: [],

      tooltipData: [],
    };
  },
  //计算属性 类似于data概念
  computed: {
    showPop() {
      return (deviceNo) => {
        //return this.carCurrentID.includes(deviceNo);
        return this.tooltipData.includes(deviceNo);
      };
    },
    carInfoBox() {
      return (item) => {
        return `${item.dtuName}(${item.typeName})`;
      };
    },
    roadStyle() {
      let status = false;
      let random = parseInt(Math.random() * 100000);
      this.carInfo.forEach((item) => {
        //if (this.carCurrentID.includes(item.deviceNo)) {
        if (this.tooltipData.includes(item.deviceNo)) {
          status = true;
        }
        //status = true;

        let tmpLoc = "";

        let startLat = item.roadStartPointLatLng.split(",")[0];
        let startLng = item.roadStartPointLatLng.split(",")[1];
        let endLat = item.roadEndPointLatLng.split(",")[0];
        let endLng = item.roadEndPointLatLng.split(",")[1];

        let tmpAngel = this.getAngle(startLng, startLat, endLng, endLat);
        //tmpAngel = tmpAngel - this.roadRotate;
        //console.log("============");
        //console.log(tmpAngel);
        if (tmpAngel >= 0 && tmpAngel < 180) {
          tmpLoc = parseFloat(item.distanceRateFromSP);
        } else {
          tmpLoc = 1 - parseFloat(item.distanceRateFromSP);
        }

        if (!window.ColorScreenCar) {
          window.ColorScreenCar = {};
        }
        if (!window.ColorScreenCar[item.dtuNum]) {
          window.ColorScreenCar[item.dtuNum] = this.roadWidth * tmpLoc - parseInt(57 / 2);
        }
        if (
          window.ColorScreenCar[item.dtuNum] ==
            this.roadWidth * tmpLoc - parseInt(57 / 2) ||
          !item.todayDistance
        ) {
          //停止
          item.driveStatus = "stop";
        } else if (
          window.ColorScreenCar[item.dtuNum] >
          this.roadWidth * tmpLoc - parseInt(57 / 2)
        ) {
          //退后
          item.driveStatus = "forward";
        } else if (
          window.ColorScreenCar[item.dtuNum] <
          this.roadWidth * tmpLoc - parseInt(57 / 2)
        ) {
          //前进
          item.driveStatus = "back";
        }
        //item.leftX = window.ColorScreenCar[item.dtuNum] + "px"; //this.roadWidth * tmpLoc - parseInt(57 / 2) + "px";
        item.leftX = (this.roadWidth - parseInt(80)) * tmpLoc + "px";
        if (!item.left) {
          item.left = item.leftX;
        }

        if (item.todayDistance && !window.ColorScreenCar[item.dtuNum]) {
          window.ColorScreenCar[item.dtuNum] = this.roadWidth * tmpLoc - parseInt(57 / 2);
        }
        //console.log(item.leftX + "-" + random);
        //console.log(item.left + "-- carLeft");
      });
      /*console.log(this.roadRotate);
      console.log(this.startLnd);
      console.log(this.startLat);
      console.log(this.endLnd);
      console.log(this.endLat);
      console.log(this.todayDistance);*/

      return {
        width: this.roadWidth + "px",
        height: this.roadHeight + "px",
        top: this.roadTop + "px",
        left: this.roadLeft + "px",
        transform: "rotateZ(" + this.roadRotate + "deg)",
        zIndex: status ? 3 : this.roadHasCar ? 2 : 1,
      };
    },
    roadFontStyle() {
      let roadRotate = -this.roadRotate - 188;
      if (roadRotate < 0) {
        roadRotate = 360 + roadRotate;
      } else if (roadRotate > 360) {
        roadRotate = 360 - roadRotate;
      }
      return {
        top: 20 + parseInt(this.roadHeight) + "px",
        position: "absolute",
        transform: "rotateZ(" + roadRotate + "deg)",
      };
    },
    getRoadIdx() {
      let idx = 0;
      idx = $.inArray(this.roadId, this.newCurrentRoad);
      return idx + 1;
    },
    // carzIndex() {
    //   return (item) => {
    //     return `${item.dtuName}(${item.typeName})`;
    //   };
    // },
    roadBoxStyle() {
      let roadColor = "none";
      let idx = 0;
      let zIndex = 0;
      idx = $.inArray(this.roadId, this.newCurrentRoad);
      if (idx >= 0 && this.newCurrentRoadInfo.length > 0) {
        if (this.newCurrentRoadInfo[idx].riskLevel == "1") {
          roadColor = "#fde66590";
        } else if (this.newCurrentRoadInfo[idx].riskLevel == "2") {
          roadColor = "#65c1fd90";
        } else if (this.newCurrentRoadInfo[idx].riskLevel == "3") {
          roadColor = "#65fdca90";
        } else {
          roadColor = "none";
        }
        zIndex = 1;
      }

      idx = $.inArray(this.roadId, this.newOtherRoad);
      if (idx >= 0 && this.newOtherRoadInfo.length > 0) {
        if (this.newOtherRoadInfo[idx].riskLevel == "1") {
          roadColor = "#fde66590";
        } else if (this.newOtherRoadInfo[idx].riskLevel == "2") {
          roadColor = "#65c1fd90";
        } else if (this.newOtherRoadInfo[idx].riskLevel == "3") {
          roadColor = "#65fdca90";
        } else {
          roadColor = "none";
        }
        zIndex = 1;
      }

      //console.log(this.roadType);
      let isParkingLot = false;
      if (this.roadType == "parkingLot") {
        roadColor = "none";
        isParkingLot = true;
      }

      return {
        background: roadColor,
        zIndex: zIndex,
        borderRadius: !isParkingLot ? "100px" : "0px",
      };
    },
    carInfoStyle() {
      return {
        transform:
          "rotate(" +
          (-parseInt(this.roadRotate) -
            188 +
            (bmeConfig.roadRotate ? bmeConfig.roadRotate : 0)) +
          "deg)",
        transformOrigin: "198px 259px",
      };
    },
    currentRoadStyle() {
      return true;
      // console.log("this.currentRoad", this.currentRoad);
      //return this.currentRoad.modelId === this.roadId;
      let result = false;
      if ($.inArray(this.roadId, this.newCurrentRoad) >= 0) {
        result = true;
      }
      if ($.inArray(this.roadId, this.newOtherRoad) >= 0) {
        result = true;
      }
      return result;
    },
    // moveStyle() {
    //   // return (item) => {
    //   let n = Math.ceil(Math.random() * 20 * 1 + 10);
    //   return {
    //     animationDuration: n + "s",
    //   };
    //   // };
    // },
  },
  //监控data中的数据变化
  watch: {
    /*currentRoad(newVal, oldVal) {
      this.newCurrentRoad = newVal;
    },*/
    currentRoadInfo(newVal, oldVal) {
      // console.log("newVal", newVal[0].modelId, "oldVal", oldVal[0].modelId);
      this.newCurrentRoadInfo = newVal;
      this.newCurrentRoad = [];
      this.newCurrentRoadInfo.forEach((item) => {
        if (item) this.newCurrentRoad.push(item?.modelId);
      });
    },
    otherRoadInfo(newVal, oldVal) {
      this.newOtherRoadInfo = newVal;
      this.newOtherRoad = [];
      this.newOtherRoadInfo.forEach((item) => {
        if (item) this.newOtherRoad.push(item?.modelId);
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //方法集合
  methods: {
    carDetailShow(item_car) {
      //console.log(item_car);
      if (item_car && item_car.deviceNo) {
        this.tooltipData.push(item_car.deviceNo);
      }
    },
    carDetailHide() {
      this.tooltipData = [];
    },
    carClick(item_car) {
      if (this.carInfo.length > 1) {
        let tmpList = [];
        this.carInfo.forEach((item) => {
          tmpList.push({
            deviceName: item.deviceName,
            dtuNum: item.dtuNum,
            driverName: item.driverName,
            account: item.account,
          });
        });
        this.$emit("handler-carMission", tmpList);
      } else if (this.carInfo.length > 0) {
        this.$emit("handler-carMission", [
          {
            deviceName: item_car.deviceName,
            dtuNum: item_car.dtuNum,
            driverName: item_car.driverName,
            account: item_car.account,
          },
        ]);
      }
    },
    getAngle(lng_a, lat_a, lng_b, lat_b) {
      var a = ((90 - lat_b) * Math.PI) / 180;
      var b = ((90 - lat_a) * Math.PI) / 180;
      var AOC_BOC = ((lng_b - lng_a) * Math.PI) / 180;
      var cosc =
        Math.cos(a) * Math.cos(b) + Math.sin(a) * Math.sin(b) * Math.cos(AOC_BOC);
      var sinc = Math.sqrt(1 - cosc * cosc);
      var sinA = (Math.sin(a) * Math.sin(AOC_BOC)) / sinc;
      var A = (Math.asin(sinA) * 180) / Math.PI;
      var res = 0;
      if (lng_b > lng_a && lat_b > lat_a) res = A;
      else if (lng_b > lng_a && lat_b < lat_a) res = 180 - A;
      else if (lng_b < lng_a && lat_b < lat_a) res = 180 - A;
      else if (lng_b < lng_a && lat_b > lat_a) res = 360 + A;
      else if (lng_b > lng_a && lat_b == lat_a) res = 90;
      else if (lng_b < lng_a && lat_b == lat_a) res = 270;
      else if (lng_b == lng_a && lat_b > lat_a) res = 0;
      else if (lng_b == lng_a && lat_b < lat_a) res = 180;
      return res;
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
.road-idx {
  text-align: center;
  line-height: 70px;
  height: 80px;
  border-radius: 80px;
  width: 80px;
  margin: auto;
  position: relative;
  color: #025e9b;
  top: 50px;
  font-size: 50px;
  font-weight: bolder;
  text-align: center;
  background: #fff;
  border: 2px solid #65c1fd;
}
@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes hide {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 2;
  }
}
.my-road {
  width: 10px;
  height: 10px;
  //background: rgb(0, 247, 255);
  position: absolute;
  pointer-events: all;
  transform-origin: left top;

  .my-road-box {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    border-radius: 100px;
    // background: chartreuse;
    /*&.showHide {
      animation-name: show;
      animation-duration: 1s;
      animation-timing-function: linear;
      animation-iteration-count: 1;
      animation-direction: normal;
    }*/
  }
  &.current {
    z-index: 3;
  }
  @keyframes carmove {
    0% {
      left: 80%;
      @include bg-box(57px, 30px, "car.png");
    }
    49% {
      left: 0%;
      @include bg-box(57px, 30px, "car.png");
    }
    50% {
      left: 0%;
      @include bg-box(57px, 30px, "re_car.png");
    }
    99% {
      left: 80%;
      @include bg-box(57px, 30px, "re_car.png");
    }
    100% {
      left: 80%;
      @include bg-box(57px, 30px, "car.png");
    }
  }
  @keyframes carmoveLeft {
    0% {
      margin-left: 0%;
    }
    100% {
      margin-left: -50%;
    }
  }
  @keyframes carmoveRight {
    0% {
      margin-left: 0%;
    }
    100% {
      margin-left: 50%;
    }
  }
  .my-car {
    position: absolute;
    //@include bg-box(85px, 45px, "car.png");
    top: 50%;
    transform: translateY(-50%);
    &.move {
      animation-name: carmove;
      animation-duration: 250s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      // animation-direction: alternate;
    }
    &.moveStop {
      @include bg-box(85px, 45px, "car.png");
    }
    &.moveLeft {
      @include bg-box(85px, 45px, "car.png");
      /*animation-name: carmoveLeft;
      animation-duration: 250s;
      animation-timing-function: ease-out;
      animation-iteration-count: infinite;*/
      // animation-direction: alternate;
    }
    &.moveRight {
      @include bg-box(85px, 45px, "re_car.png");
      /*animation-name: carmoveRight;
      animation-duration: 250s;
      animation-timing-function: ease-out;
      animation-iteration-count: infinite;*/
      // animation-direction: alternate;
    }
    .carInfo {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      white-space: nowrap;
      position: absolute;
      left: -184px;
      top: -228px;
      @include bg-box(419px, 254px, "carInfo.png");
      padding-top: 29px;
      &.out {
        animation-name: show;
        animation-duration: 1s;
        animation-timing-function: linear;
        animation-iteration-count: 1;
      }
      .typeName {
        height: 34px;
        font-size: 30px;
        font-weight: 600;
        color: #ffffff;
        line-height: 34px;
        margin-bottom: 25px;
      }
      .typeName2 {
        height: 30px;
        font-size: 30px;
        color: #ffffff;
        line-height: 30px;
        margin-bottom: 15px;
        span {
          color: rgba(75, 224, 255, 1);
          font-weight: 500;
        }
      }
    }
  }
}
.plus-icon-enter-active {
  transition: opacity 1s;
}
.plus-icon-enter {
  opacity: 0;
}
.plus-icon-leave-active {
  transition: opacity 1s;
}
.plus-icon-leave-to {
  opacity: 0;
}
</style>
